import React from 'react';
import { DayChanges, MinutesWithChangeRequest } from './types';
import { DayTimeEntriesChangesPopover } from '../DayTimeEntries/DayTimeEntriesChangesPopover/DayTimeEntriesChangesPopover';
import { DurationCell } from '../../../components/TimeSheetsTable/Cells/DurationCell';
import { AutoBreakDeductionStatus } from '../../../components/AutoBreaks/shared';
import { BreakDeductionStatusIndicator } from '../../../components/AutoBreaks/BreakDeductionStatusIndicator';

type Props = {
  timeSheetId: string;
  employeeId: string;
  day: string;
  dayChanges: DayChanges;
  fieldKey: string;
  value: MinutesWithChangeRequest;
  breakDeductionStatus?: AutoBreakDeductionStatus;
};

export const ManagerDurationCell: React.FC<Props> = ({
  fieldKey,
  timeSheetId,
  employeeId,
  day,
  dayChanges,
  value,
  breakDeductionStatus,
}) => {
  const popover = (
    <DayTimeEntriesChangesPopover
      fieldKey={fieldKey}
      timeSheetId={timeSheetId}
      employeeId={employeeId}
      day={day}
      dayChanges={dayChanges}
    />
  );
  return (
    <div className="d-flex gap-1 align-items-center">
      <DurationCell value={value} popover={popover} />
      {fieldKey === 'breakMinutes' && (
        <BreakDeductionStatusIndicator
          status={breakDeductionStatus}
          id={`deduction-success-${timeSheetId}-${day}-${fieldKey}`}
        />
      )}
    </div>
  );
};
